module.exports = __webpack_public_path__ + "img/storm-red.bb7d8626.svg";